import { render, staticRenderFns } from "./Operation.vue?vue&type=template&id=f5a7aac6&scoped=true&"
import script from "./Operation.vue?vue&type=script&lang=js&"
export * from "./Operation.vue?vue&type=script&lang=js&"
import style0 from "./Operation.vue?vue&type=style&index=0&id=f5a7aac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a7aac6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/yicai/wanhuahengxin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout})
